import { render, staticRenderFns } from "./PaymentError.vue?vue&type=template&id=1039e184&scoped=true"
import script from "./PaymentError.vue?vue&type=script&lang=js"
export * from "./PaymentError.vue?vue&type=script&lang=js"
import style0 from "./PaymentError.vue?vue&type=style&index=0&id=1039e184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1039e184",
  null
  
)

export default component.exports